const menu={key:"aiGlobalExecutionSettings",route:"/ai-development/execution-settings",label:"aiDevelopment.globalExecutionSettings",permission:"ai.development.admin",icon:"faSliders",group:"aiDevelopment",groupLabel:"aiDevelopment.title",order:21};
export default menu;
